import { BorderRadius, Color, Spacing } from '@billy/design-system'
import { css } from '@emotion/core'
import styled from '@emotion/styled'

import { animateGradient } from '../utils'

interface PlaceholderLineWrapperProps {
  header?: boolean
  width: string
}

const commonStyles = css`
  border-radius: ${BorderRadius.R4};
  line-height: 24px;
  ${animateGradient({ color1: Color.Lavender100, color2: Color.Lavender50 })}
`

export const PlaceholderLineWrapper = styled.div<PlaceholderLineWrapperProps>`
  width: ${({ width }) => width};
  height: ${({ header }) => (header ? 16 : 10)}px;
  margin: ${Spacing.S8} 0;
  ${commonStyles};
`

export const ThumbnailWrapper = styled.div`
  ${commonStyles};
  width: 50px;
  height: 50px;
  margin: ${Spacing.S8};
  margin-left: 0;
`
